export default "/images/the-irish-times.svg?538ffbaaeda06e9bb19b116331ce5550";